// these have to match the backend enum typ
export enum RatioCalculationType {
  'HEADCOUNT',
  'HEADCOUNT_WITH_VACANCY',
  'HEADCOUNT_WITH_UTILIZATION',
  'WORK_SEATS',
}

// need to add more to enum in backend when expanding this list
export interface IProjectSettings {
  fileCabinetRatioCalculationType: RatioCalculationType;
  lockerRatioCalculationType: RatioCalculationType;
}

export interface ISettingsState {
  projectSettings: IProjectSettings;
}

// default project settings
export const defaultProjectSettings: IProjectSettings = {
  fileCabinetRatioCalculationType: RatioCalculationType.WORK_SEATS,
  lockerRatioCalculationType: RatioCalculationType.WORK_SEATS,
};
